import { config } from './config';

declare global {
  interface Window {
    grecaptcha?: {
      ready: (cb: () => void) => void;
      execute: (siteKey: string, opts: { action: string }) => Promise<string>;
    };
  }
}

let loaded = false;
let loadPromise: Promise<void> | null = null;

function loadRecaptcha(): Promise<void> {
  if (loaded) return Promise.resolve();
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[src*="recaptcha"]') as HTMLScriptElement | null;
    if (existing) {
      setTimeout(() => { loaded = true; resolve(); }, 500);
      return;
    }
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${config.captchaSiteKey}`;
    script.async = true;
    script.defer = true;
    script.onload = () => { loaded = true; resolve(); };
    script.onerror = () => { loadPromise = null; reject(new Error('Failed to load reCAPTCHA')); };
    document.head.appendChild(script);
  });
  return loadPromise;
}

export async function getCaptchaToken(): Promise<string> {
  await loadRecaptcha();
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      reject(new Error('Security verification not available. Please refresh the page.'));
      return;
    }
    try {
      window.grecaptcha.ready(() => {
        try {
          window.grecaptcha!
            .execute(config.captchaSiteKey, { action: 'submit' })
            .then((token) => {
              if (token && typeof token === 'string') resolve(token);
              else reject(new Error('Security verification failed. Please try again.'));
            })
            .catch(() => reject(new Error('Security verification failed. Please try again.')));
        } catch (_e) {
          reject(new Error('Security verification failed. Please try again.'));
        }
      });
    } catch (_e) {
      reject(new Error('Security verification failed. Please try again.'));
    }
  });
}


